"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconStarFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconStarFilled = function SvgIconStarFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.731 4.68a.514.514 0 00-.49-.374H7.606L6.568 1.11 6.491.872 6.489.868A.534.534 0 006.254.57L6.247.565a.5.5 0 00-.067-.03C6.17.53 6.162.525 6.152.522L6.135.516C6.124.513 6.113.513 6.102.511A.481.481 0 006.047.5h-.04c-.02-.001-.041 0-.062.001l-.033.006c-.016.003-.031.004-.047.008-.008.002-.016.006-.024.01l-.008.002a.53.53 0 00-.322.34L5.51.872c-.372 1.145-.743 2.29-1.116 3.434H.76a.514.514 0 00-.491.374c-.065.237.046.438.234.574L3.4 7.36l-1.053 3.241-.078.24c-.13.402.384.839.748.574L6 9.248l2.78 2.02.202.147c.365.265.88-.172.748-.575L8.6 7.36a43675.134 43675.134 0 002.898-2.106c.187-.136.299-.338.233-.575z",
    fill: "currentColor"
  }));
};

exports.SvgIconStarFilled = SvgIconStarFilled;